import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-it-helpdesk',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterModule, FeatureHero, FeatureRow],
})
export class ITHelpdesk {
  whatIsParagraphs = ["IT Help Desk Software is software designed to assist users in providing technical support to customers. It typically includes features such as ticketing, a knowledge base, asset management, and self-service portals. It is used to automate support processes and improve customer service."];

  howItHelpsParagraphs = [
    "Infraon Help Desk is an AI-powered customer service platform that provides customers with automated help and support. It uses natural NLP technology to understand customer queries and provide personalized solutions.",
    "It also provides automated solutions to frequently asked questions (FAQs) and helps customers find answers quickly and easily. The platform can provide automated customer service, 24/7 customer support, and live chat support. Using the Infraon Help Desk, customer service can be improved by providing timely and accurate solutions, decreasing customer wait times, and increasing customer satisfaction. Additionally, Infraon Help Desk helps reduce operational costs by automating customer service operations and providing comprehensive customer insights."
  ];

  keyFeaturesItems = [
    'KPI Dashboard',
    'Bulk Excel Import/ Export',
    'Custom Reports',
    'Custom Roles',
    'Report Export',
    'Custom Alerts',
    'Scheduled Reports',
    'Customizable Fields'
  ];

  constructor() {}

}